export default "__VITE_ASSET___oMNwtVF__"